import React, { ReactChildren } from 'react';
import { WithStyles, createStyles, Drawer } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

import { components as headerComponents } from './components/header';
import { components as footerComponents } from './components/footer';

const { Header } = headerComponents;
const { Footer } = footerComponents;

const styles = (theme: Theme) => createStyles({
  mainRoot: {
    padding: '16px',
    position: 'relative',
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    fontFamily: '"Nunito", sans-serif',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&:has(.headerSticky)': {
      paddingTop: 0
    }
  },
  '.math-editor-workplace-container': {
    height: "190px",
  },
  drawerPaper: {
    width: drawerWidth,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
});

interface MainLayoutProps extends WithStyles<typeof styles> {
  children: ReactChildren,
}
const drawerWidth = 80;

const MainLayout = ({ classes, children }: MainLayoutProps) => {
  return (
    <>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={true}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Header />
      </Drawer>
      <main className={classes.mainRoot}>
        {children}
      </main>
      {/* <Footer /> */}
    </>
  );
}

export default withStyles(styles)(MainLayout);